import { Injectable, EventEmitter } from '@angular/core';
var NgFxController = (function () {
    function NgFxController() {
        this.surfaces = {};
        this.onEvent = new EventEmitter();
    }
    NgFxController.prototype.createSurface = function (id, controls) {
        this.surfaces[id] = {
            id: id,
            controls: controls
        };
    };
    NgFxController.prototype.getSurface = function (id) {
        return this.surfaces[id];
    };
    NgFxController.prototype.destroySurface = function (id) {
        delete this.surfaces[id];
    };
    NgFxController.decorators = [
        { type: Injectable },
    ];
    NgFxController.ctorParameters = function () { return []; };
    return NgFxController;
}());
export { NgFxController };
if (false) {
    NgFxController.prototype.surfaces;
    NgFxController.prototype.onEvent;
}
